// @flow
import path from 'ramda/es/path';
import map from 'ramda/es/map';
import fromPairs from 'ramda/es/fromPairs';
import pipe from 'ramda/es/pipe';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_BREADCRUMB_REQUEST = 'SHOP_BREADCRUMB_REQUEST';
export const SHOP_BREADCRUMB_SUCCESS = 'SHOP_BREADCRUMB_SUCCESS';
export const SHOP_BREADCRUMB_FAILURE = 'SHOP_BREADCRUMB_FAILURE';
export const SHOP_BREADCRUMB_CLEAR = 'SHOP_BREADCRUMB_CLEAR';

const transform = pipe(
  res => path(['data', 'data'], res) || [],
  map(({ name, slug }) => ([slug, name])),
  fromPairs,
);

/**
 * Запрос заголовков slugs для создания breadcrumb
 */
export const breadcrumbFetch = (slugs: Array<string>) => async (dispatch: Function) => {
  const params = { slug_ids: slugs };
  dispatch(action(SHOP_BREADCRUMB_REQUEST, params));
  try {
    const res = await shopApiRequest('categories/filter', 'get', { params });
    const data = transform(res);
    dispatch(action(SHOP_BREADCRUMB_SUCCESS, data));
    return true;
  } catch (error) {
    dispatch(action(SHOP_BREADCRUMB_FAILURE, {
      err: 'Запрос навигации к родительским элементам не удался',
      params,
      error,
    }));
    return false;
  }
};
